import React, { useState, useContext, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { isMobile } from "react-device-detect";
import findIndex from "lodash/findIndex";
import pick from "lodash/pick";
import pickBy from "lodash/pickBy";
import findKey from "lodash/findKey";
import { useTranslation } from "react-i18next";
import Col from "react-bootstrap/Col";
import { FormControl, InputGroup, Form } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import { reducer } from "../../../context/";
import actionType from "../../../context/actionType";
import {
  FormHeading,
  Divider,
  Footnote,
  OptionText,
  Title,
  PolicyTextSmall,
} from "../FormScreenStyles";
// import PrivacyPolicy from '../PrivacyPolicy';
import LabelInput from "../LabelInput";
import FormDropdown from "../FormDropdown";
import AssetListItem from "../../assets/screens/AssetListScreen/components/AssetList/Sections/ListItems/AssetListItem";
import GeneralProjectItem from "../../assets/screens/AssetListScreen/components/AssetList/Sections/ListItems/GeneralProjectItem";
import {
  COUNTRIES,
  REGIONS,
  DISTRICTS,
  AREAS,
  SALUTATIONS,
} from "./formOptions";
import Api from "../../../helpers/Api";
import { UserToken } from "../../../interface/Server/";
import { ButtonText } from "../../../components/Text";
import { logResponse } from "../../../helpers/Logger";
import CheckBox from "../../../components/Common/CheckBox";
import { isInvalidSession, resetSession } from "../../../helpers/ErrorHandler";

import { I18nextProvider } from "react-i18next";
import i18n_address from "../../../i18n_addr";

const TOGGLE_SWITCH = "TOGGLE_SWITCH";
const HK_AREA_CODE = "852";
const MIN_PHONE_LENGTH = 8;

const textStyle = (useChi: boolean) => ({
  ...(useChi
    ? {
        fontFamily: "Microsoft JhengHei",
      }
    : {
        fontFamily: ["Rambla", "Arial"],
      }),
  fontStyle: "normal",
  fontStretch: "normal",
  lineHeight: "normal",
  letterSpacing: "normal",
  fontSize: "100%",
  color: "black",
  // color: '#78848f',
});
const LANGUAGE = {
  English: "English",
  繁中: "Traditional Chinese",
  简中: "Simplified Chinese",
};

const VENUES = [
  "WKCDA General",
  "Art Park",
  "Freespace",
  "Hong Kong Palace Museum",
  "Lyric Theatre Complex",
  "M+",
  "Xiqu Centre",
];

const VENUE_VALUE_MAPPING: { [key: string]: any } = {
  westKowloonGeneral: "WKCDA General",
  artPark: "Art Park",
  palaceMuseum: "Hong Kong Palace Museum",
  mPlus: "M+",
  xiquCentre: "Xiqu Centre",
  lyricTheatre: "Lyric Theatre Complex",
  freeSpace: "Freespace",
  "WKCDA General": "WKCDA General",
  "Art Park": "Art Park",
  "Hong Kong Palace Museum": "Hong Kong Palace Museum",
  "M+": "M+",
  "Xiqu Centre": "Xiqu Centre",
  "Lyric Theatre Complex": "Lyric Theatre Complex",
  Freespace: "Freespace",
};

const notEmpty = (value: string) => !!value;

const arrayNotEmpty = (array: string[]) => array && array.length > 0;

const hasReceiptNotEmpty = (value: string, form: { [key: string]: any }) =>
  !form.receipt || (form.receipt && !!value && value.length);

const greaterThanEqual = (minLength: number) => (value: string) =>
  value.length >= minLength;

const validationRules: { [key: string]: any } = {
  primaryEmail: (email: string) => {
    const emailRegex =
      /^[a-zA-Z0-9]+[\w_\.-]*@[\w\.]*[\w-\.]+\.{1}[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  },
  firstName: notEmpty,
  lastName: notEmpty,
  areaCode: notEmpty,
  phoneNumber: (num: string) =>
    notEmpty(num) && greaterThanEqual(MIN_PHONE_LENGTH)(num),
  address1: hasReceiptNotEmpty,
  address2: hasReceiptNotEmpty,
  preferredLanguage: notEmpty,

  //@TODO C4Sheep. enable mandaotry
  salutation: notEmpty,
  tcPicsRead: notEmpty,
  // customerInterest: arrayNotEmpty,
};

interface Props extends RouteComponentProps {}

const DonationForm: React.FunctionComponent<Props> = (props) => {
  const [invalid, setInvalid] = useState<{ [key: string]: any }>({
    primaryEmail: false,
    firstName: false,
    lastName: false,
    areaCode: false,
    phoneNumber: false,
    address1: false,
    address2: false,
    preferredLanguage: false,
    salutation: false,
    tcPicsRead: false,
  });
  const [form, setForm] = useState<{ [key: string]: any }>({
    firstName: "",
    lastName: "",
    // firstNameZh: '',
    // lastNameZh: '',
    preferredLanguage: "",
    receipt: false,
    tcPicsRead: false,
    receiveEventInfo: true,
    receiveDevUpdate: false,
    salutation: sessionStorage.getItem("SESSION_SALUTATION") || "",
    areaCode: sessionStorage.getItem("SESSION_MOBILECC") || HK_AREA_CODE,
    phoneNumber: sessionStorage.getItem("SESSION_MOBILE") ||  "",
    // dob: '',
    primaryEmail: sessionStorage.getItem("SESSION_EMAIL") || "",
    address1: "",
    address2: "",
    country: "Hong Kong SAR",
    region: "",
    district: "",
    area: "",
    customerInterest: [],
    overrideWestkowloonAccounts: false,
  });
  // const [link, setLink] = useState('');
  const [modalTarget, setModalTarget] = useState("");
  const [showLink, setShowLink] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [hasDefaultLg, setHasDefaultLg] = useState(false);

  const { t, i18n } = useTranslation();
  const { t: t_addr, i18n: i18n_addr } = useTranslation(null, {
    i18n: i18n_address,
  });
  const useChinese = i18n.language === "zhTW" || i18n.language === "cn";
  const [tributeAmount, setTributeAmount] = useState(0);
  const { formReducer, configReducer } = useContext(reducer);

  const [donationForm, setDonationForm] = useState("normal");

  // const [formSubmitted, setFormSubmitted] = useState(false);
  // const isGeneralProject = !!formReducer.state.selectedProject;
  const getMappedInterest = (interests: string[]): string[] => {
    return interests.map((interest) => {
      const keyVal = pickBy(VENUE_VALUE_MAPPING, (value) => value === interest);
      return Object.keys(keyVal)[0];
    });
  };
  useEffect(() => {
    console.log("flag");
    const loadAmount = sessionStorage.getItem("DONATION_AMOUNT");
    setTributeAmount(loadAmount ? Number(loadAmount) : 0); //TODO JACK: Load tribute amount and set to state and display using 'tributeAmount'
    const token = sessionStorage.getItem("SESSION_TOKEN");
    if (!!token && typeof JSON.parse(token) === "object") {
      setIsLogin(true);
    }

    const formDetails = sessionStorage.getItem("SAVED_FORM_DETAILS");

    // JOSH TODO - add prompt alert saying form will not be saved unless press revise if go back
    if (!!formDetails) {
      // user saved form details after pressing REVISE, load form details and clear form from sessionStorage
      const parsedForm = JSON.parse(formDetails);
      setHasDefaultLg(!!parsedForm.userLanguage);
      setForm((prevState: Object) => ({
        ...prevState,
        ...parsedForm,
      }));
      // sessionStorage.removeItem('SAVED_FORM_DETAILS'); // move save form removal to TODO back action
      return;
    }
    if (!token) {
      return;
    }
    const parsedToken = JSON.parse(token); //as UserToken;
    const prefillForm = {} as { [key: string]: any };
    if (parsedToken) {
      console.log("parsedToken", parsedToken);

      //            const nameParts = parsedToken.userFullName.split(' ');
      //            prefillForm.lastName = nameParts[0] || '';
      //            prefillForm.firstName = nameParts[1] || '';

      console.log("parsedToken", parsedToken);
      setHasDefaultLg(!!parsedToken.userLanguage);
      setForm((prevState: Object) => ({
        ...prevState,
        ...parsedToken,
        firstName: parsedToken.userFirstName || "",
        lastName: parsedToken.userLastName || "",
        customerInterest: parsedToken.fundraisingInterest
          ? getMappedInterest(parsedToken.fundraisingInterest.split(";"))
          : [],
        address1: parsedToken.primaryAddressLine1,
        address2: parsedToken.primaryAddressLine2,
        phoneNumber: parsedToken.userMobile,
        tcPicsRead: parsedToken.tcRead && parsedToken.picsRead,
        preferredLanguage: parsedToken.userLanguage,
        ...prefillForm,
      }));
    }
    // set userLanguage based on userToken settings

    //@TODO zekta fixed
    //There are no user lang now

    /*
        const userLang = !!parsedToken.userLanguage && parsedToken.userLanguage.indexOf('English') > -1 ? 'English' : 'zhTW';
        if(!i18n.language || i18n.language !== userLang) {
            i18n.changeLanguage(userLang);
            i18n_addr.changeLanguage(userLang)
        }
        if(!i18n_addr.language || i18n_addr.language !== userLang) {
            i18n_addr.changeLanguage(userLang)
        }
        */
  }, []);
  const getValue = (
    prevState: { [key: string]: any },
    param: string,
    value: any
  ) => {
    setInvalid((prevState: Object) => ({
      ...prevState,
      [param]: false,
    }));
    if (value === TOGGLE_SWITCH && prevState.hasOwnProperty(param)) {
      return !prevState[param];
    }
    if (param === "customerInterest") {
      const interests = prevState.customerInterest;
      const updatedInterest = [...interests];
      const valueExists = findIndex(
        interests,
        (existingVal) => existingVal === value
      );
      if (valueExists === -1) {
        updatedInterest.push(value);
      } else {
        updatedInterest.splice(valueExists, 1);
      }
      return updatedInterest;
    }
    if (param === "phoneNumber" || param === "areaCode") {
      return value.replace ? value.replace(/\D/g, "") : value;
    }
    return value;
  };

  const setOption = (param: string) => (value: any) => {
    setForm((prevState: Object) => ({
      ...form,
      [param]: getValue(prevState, param, value),
    }));
  };
  useEffect(() => {
    setForm((prevState: { [key: string]: any }) => {
      if (prevState.country && COUNTRIES[form.country] !== prevState.country) {
        return {
          ...prevState,
          region: "",
          district: "",
        };
      }
      return prevState;
    });
  }, [form.country]);
  useEffect(() => {
    const asset = sessionStorage.getItem("SELECTED_ASSET");
    const project = sessionStorage.getItem("SELECTED_PROJECT");
    const selected = asset
      ? { selectedAsset: JSON.parse(asset) }
      : project
      ? { selectedProject: JSON.parse(project) }
      : undefined;

    console.info("------");
    console.info(selected);

    setDonationForm("normal");
    if (
      selected &&
      selected.selectedProject &&
      selected.selectedProject.donationForm
    ) {
      setDonationForm(selected.selectedProject.donationForm);
    }

    if (selected) {
      formReducer.dispatch({
        type: actionType.form.REFRESH_STAGE,
        payload: {
          nextStep: 2,
          ...selected,
        },
      });
      formReducer.dispatch({
        type: actionType.form.SET_SCREEN,
        payload: {
          screen: "donationForm",
        },
      });
    }
  }, []);
  useEffect(() => {
    const anyInvalid = findKey(invalid, function (invalidValue) {
      return invalidValue;
    });
    if (anyInvalid === "tcPicsRead") {
      return;
    }
    if (anyInvalid) {
      window.scrollTo(0, 0);
    }
  }, [invalid]);
  const renderButton = (isMobile: boolean = false) => (
    <Row
      style={
        isMobile
          ? {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: 0,
              margin: 0,
              marginTop: 32,
            }
          : {
              display: "flex",
              justifyContent: "space-between",
              padding: 0,
              margin: 0,
              marginTop: 32,
            }
      }
    >
      <Button
        size={"lg"}
        onClick={() => {
          // on revise - save current input to SAVED_INPUT and go back (need to clear upon loading this page)
          sessionStorage.setItem("SAVED_FORM_DETAILS", JSON.stringify(form));
          props.history.goBack();
        }}
        style={{
          width: 188,
          height: 57,
          backgroundColor: "#2c3e50",
          borderRadius: 0,
          marginBottom: isMobile ? 12 : 0,
        }}
        variant={"outline-light"}
      >
        <ButtonText white>{t("form.revise")}</ButtonText>
      </Button>
      <Button
        type="submit"
        size={"lg"}
        onClick={() => {
          sessionStorage.setItem("SAVED_FORM_DETAILS", JSON.stringify(form));
          let auth = sessionStorage.getItem("auth");
          console.log(form);
          const invalidFields: { [key: string]: any } = {}; // add invalid params into object and de-structure into setInvalid
          const fieldNames = Object.keys(form);
          const validation: { [key: string]: any } = {
            ...validationRules,
          };
          fieldNames.forEach((fieldName: string) => {
            if (
              validation[fieldName] &&
              !validation[fieldName](form[fieldName], form)
            ) {
              invalidFields[fieldName] = true;
            }
          });
          if (Object.keys(invalidFields).length > 0) {
            setInvalid((prevState: Object) => ({
              ...prevState,
              ...invalidFields,
            }));
            return;
          }
          const requestData: { [key: string]: any } = pick(form, [
            "firstName",
            "lastName",
            "preferredLanguage",

            //@TODO C4Sheep salutation
            //"salutation",
            "primaryEmail",
            "collectInfo",
            "receiveEventInfo",
          ]);
          // Since T&C and PICS are same check box set both to true
          if (form.tcPicsRead) {
            requestData.tcRead = true;
            requestData.picsRead = true;
          }
          // missing: donorNameInReceipt, fundraisingInterest, firstNameChi, lastNameChi, westKowloonENewsletter
          requestData.customerInterest_crm = form.receiveDevUpdate
            ? "development"
            : "";

          requestData.customerInterest = null;
          if (form.customerInterest.length > 0) {
            const mappedInterest = form.customerInterest.map(
              (interest: string) => {
                return VENUE_VALUE_MAPPING[interest] || interest; // get mapped values instead of display name (e.g. WKCDA General)
              }
            );
            requestData.customerInterest = mappedInterest.join(";");
          }
          // if areaCode === 852 (HK) no need, otherwise append +XXX
          requestData.mobile = `${form.areaCode === HK_AREA_CODE ? "" : "+"}${
            form.areaCode
          }${form.phoneNumber}`;
          requestData.primaryAddressLine1 = form.address1;
          requestData.primaryAddressLine2 = form.address2;
          const formatDropdownSelect = (value: string) =>
            value ? `${value},` : "";
          requestData.primaryAddressLine3 = `${formatDropdownSelect(
            form.area
          )}${formatDropdownSelect(form.district)}${formatDropdownSelect(
            form.region
          )}`;
          var CnR: string = `${formatDropdownSelect(form.country)}`;
          //remove trailing ","
          if (CnR.substring(CnR.length - 1) == ",") {
            CnR = CnR.substring(0, CnR.length - 1);
          }
          requestData.addressCountryOrRegion = CnR;
          requestData.overrideWestkowloonAccounts =
            form.overrideWestkowloonAccounts;

          requestData.salutation =
            form.salutation != "" ? form.salutation : "No honorific required";
          //                        requestData.salutation=form.salutation;

          const apiBody = {
            //customerInterest: requestData.customerInterest,
            customerInterest: requestData.customerInterest_crm, // save recieve dev info or not
            donorNameInReceipt: `${requestData.firstName} ${requestData.lastName}`,
            firstName: requestData.firstName,
            lastName: requestData.lastName,
            //fundraisingInterest: requestData.customerInterest,
            fundraisingInterest: requestData.customerInterest, //receiveDevUpdate?"development":"",
            // fundraisingInterest: 'WKCDA General;M+',
            mobile: requestData.mobile,
            picsRead: requestData.picsRead,
            preferredLanguage: LANGUAGE[requestData.preferredLanguage],
            primaryAddressLine1: requestData.primaryAddressLine1,
            primaryAddressLine2: requestData.primaryAddressLine2,
            primaryAddressLine3: requestData.primaryAddressLine3,
            addressCountryOrRegion: requestData.addressCountryOrRegion,
            primaryEmail: requestData.primaryEmail,
            salutation: requestData.salutation,
            tcRead: requestData.tcRead,
            westKowloonENewsletter: requestData.receiveEventInfo,
            overrideWestkowloonAccounts:
              requestData.overrideWestkowloonAccounts,
            logined: isLogin,
            ReceiptHandling: "Handle Electronically",
          };
          /*
                        if(!form.receipt) {
                            delete apiBody['primaryAddressLine1'];
                            delete apiBody['primaryAddressLine2'];
                            delete apiBody['addressCountryOrRegion'];
                        }*/

          console.info(form);

          if (!form.receipt) {
            //            delete apiBody["primaryAddressLine1"];
            //            delete apiBody["primaryAddressLine2"];
            //            delete apiBody["addressCountryOrRegion"];
            apiBody["ReceiptHandling"] = "Handle Electronically";
          } else {
            apiBody["ReceiptHandling"] = "Hard Copies from DS";
          }

          const headers = {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: "" + auth,
          };
          fetch(`${Api.path(window.location)}/donate/personalInfo`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(apiBody),
          })
            .then((result) => {
              if (result.status === 401) {
                throw "Invalid Session";
              }
              return result.json();
            })
            .then((resJson) => {
              logResponse(
                configReducer.state.debugMode,
                `personalInfo: ${resJson.msg}`
              );
              if (isInvalidSession(resJson)) {
                throw "Invalid Session";
              }
              if (resJson.msg == "OK") {
              } else {
              }
            })
            .catch(() => {
              resetSession(formReducer);
            });
          formReducer.dispatch({
            type: actionType.form.SET_USERNAME,
            payload: {
              userName: `${requestData.firstName} ${requestData.lastName}`,
            },
          });
          // console.log('attempting to submit form:', form);
          props.history.push("/auth/payment/confirm");
        }}
        style={{
          width: 188,
          height: 57,
          backgroundColor: "#2c3e50",
          borderRadius: 0,
          marginBottom: isMobile ? 12 : 0,
        }}
        variant={"outline-light"}
      >
        <ButtonText white>{t("confirm")}</ButtonText>
      </Button>
    </Row>
  );

  const renderAddressLines = (modifier: string = "") => (
    <>
      <InputGroup>
        <LabelInput
          label={t("form.addressLine1")}
          placeholder={t("form.roomFloorBlock")}
          handleOnChange={setOption("address1" + modifier)}
          style={{ marginBottom: 11 }}
          isInvalid={invalid.address1}
        />
      </InputGroup>
      <InputGroup>
        <LabelInput
          label={t("form.addressLine2")}
          placeholder={t("form.buildingEstateStreet")}
          handleOnChange={setOption("address2" + modifier)}
          isInvalid={invalid.address2}
        />
      </InputGroup>
      <I18nextProvider i18n={i18n_addr}>
        <InputGroup
          as={Row}
          style={{
            padding: 0,
            margin: 0,
            marginTop: 18,
            minHeight: 44,
            flexDirection: isMobile ? "column" : "row",
          }}
        >
          <Col style={{ padding: 0, margin: 0, marginRight: 10 }}>
            <FormDropdown
              textStyle={textStyle(useChinese)}
              menuStyle={{ color: "black", width: "100%" }}
              options={COUNTRIES}
              currentSelection={t_addr(form[`country${modifier}`])}
              placeholder={t_addr("form:hongKong")}
              onClick={(country: any) =>
                setOption("country" + modifier)(country)
              }
            />
          </Col>
          {form[`country${modifier}`] === "Hong Kong SAR" && (
            <>
              <Col
                style={{
                  padding: 0,
                  margin: 0,
                  marginRight: 10,
                  ...(isMobile ? { marginTop: 8 } : { marginLeft: 8 }),
                }}
              >
                <FormDropdown
                  textStyle={textStyle(useChinese)}
                  menuStyle={{ color: "black", width: "100%" }}
                  options={
                    REGIONS[form[`country${modifier}`]]
                      ? REGIONS[form[`country${modifier}`]]
                      : []
                  }
                  currentSelection={t_addr(form[`region${modifier}`])}
                  placeholder={t_addr("form:region")}
                  onClick={(region: any) =>
                    setOption("region" + modifier)(region)
                  }
                />
              </Col>
              <Col
                style={{
                  padding: 0,
                  margin: 0,
                  ...(isMobile ? { marginTop: 8 } : { marginLeft: 8 }),
                }}
              >
                <FormDropdown
                  textStyle={textStyle(useChinese)}
                  menuStyle={{ color: "black", width: "100%" }}
                  options={
                    DISTRICTS[form[`region${modifier}`]]
                      ? DISTRICTS[form[`region${modifier}`]]
                      : []
                  }
                  currentSelection={t_addr(form[`district${modifier}`])}
                  placeholder={t_addr("form:district")}
                  onClick={(district: any) =>
                    setOption("district" + modifier)(district)
                  }
                />
              </Col>
              <Col
                style={{
                  padding: 0,
                  margin: 0,
                  ...(isMobile ? { marginTop: 8 } : { marginLeft: 8 }),
                }}
              >
                <FormDropdown
                  textStyle={textStyle(useChinese)}
                  menuStyle={{ color: "black", width: "100%" }}
                  options={
                    AREAS[form[`district${modifier}`]]
                      ? AREAS[form[`district${modifier}`]]
                      : []
                  }
                  currentSelection={t_addr(form[`area${modifier}`])}
                  placeholder={t_addr("form:area")}
                  disabled={true}
                  onClick={(area: any) => setOption("area" + modifier)(area)}
                />
              </Col>
            </>
          )}
        </InputGroup>
      </I18nextProvider>
    </>
  );

  let assetName = "";
  let assetPrice = "";
  if (formReducer.state && formReducer.state.selectedAsset) {
    assetName = formReducer.state.selectedAsset.englishName;
    assetPrice = `${formReducer.state.selectedAsset.giftAmountCurrency}${formReducer.state.selectedAsset.giftAmount}`;
  }
  return (
    <Container
      style={{
        width: "100%",
        padding: 0,
        ...(isMobile ? { paddingLeft: 8, paddingRight: 8 } : {}),
      }}
    >
      <Row style={{ padding: 0, margin: 0 }}>
        <Col style={{ padding: 0, margin: 0 }} xs={0} sm={1} md={1} lg={1} />
        <Col style={{ padding: 0, margin: 0 }} xs={12} sm={10} md={10} lg={10}>
          {/* <FormTitle>Donation amount <GreenTitle>{assetPrice}</GreenTitle> to <AltGreenTitle>{assetName}</AltGreenTitle></FormTitle> */}
          <Title useChinese={useChinese}>{t("selectedItem")}</Title>
          <Col style={{ padding: 0, margin: 0, paddingTop: 0, marginTop: 0 }}>
            {formReducer.state.selectedAsset && (
              <AssetListItem
                displayImage
                asset={formReducer.state.selectedAsset}
                hideButton
                nameplateDisplay
                isMobile={isMobile}
              />
            )}
            {formReducer.state.selectedProject && (
              <GeneralProjectItem
                item={formReducer.state.selectedProject}
                hideButton
                nameplateDisplay
                amount={tributeAmount}
              />
            )}
          </Col>
          <FormHeading useChinese={useChinese}>
            {t("form.personalInfo")}
          </FormHeading>
          <Footnote useChinese={useChinese} style={{ marginBottom: 9 }}>
            {t("form.mustInput")}
          </Footnote>

          <Divider />
          <Form
            onSubmit={(e: any) => {
              console.log("handle", e);
              e.preventDefault();
            }}
          >
            <InputGroup
              as={Row}
              id="container-title-english-name"
              style={{ padding: 0, margin: 0, marginTop: 18 }}
            >
              <Col
                style={{
                  padding: 0,
                  margin: 0,
                  ...(isMobile ? { flex: 1 } : { flex: 0, minWidth: 150 }),
                }}
              >
                <div>
                  <FormDropdown
                    textStyle={textStyle(useChinese)}
                    menuStyle={{
                      color: "black",
                      width: "100%",
                      ...(invalid.salutation ? { borderColor: "red" } : {}),
                    }}
                    options={SALUTATIONS}
                    currentSelection={
                      t(form.salutation.replace(".", "")) || form.salutation
                    }
                    placeholder={t("form.title")}
                    isInvalid={invalid.salutation}
                    onClick={(title: any) => setOption("salutation")(title)}
                    language={i18n.language}
                  />
                </div>
                {isMobile && (
                  <>
                    <LabelInput
                      isMobile
                      value={form.firstName || ""}
                      label={t("form.firstName")}
                      handleOnChange={setOption("firstName")}
                      isInvalid={invalid.firstName}
                      style={{
                        marginTop: 9,
                        display: "flex",
                        flexDirection: "row",
                      }}
                    />
                    <LabelInput
                      isMobile
                      value={form.lastName || ""}
                      label={t("form.lastName")}
                      handleOnChange={setOption("lastName")}
                      isInvalid={invalid.lastName}
                      style={{
                        marginTop: 9,
                        display: "flex",
                        flexDirection: "row",
                      }}
                    />
                  </>
                )}
              </Col>
              {!isMobile && (
                <div style={{ flex: 1, marginLeft: 13 }}>
                  <LabelInput
                    value={form.firstName || ""}
                    label={t("form.firstName")}
                    handleOnChange={setOption("firstName")}
                    isInvalid={invalid.firstName}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginBottom: 8,
                    }}
                    inputProps={{ style: { fontSize: "16px" } }}
                  />
                  <LabelInput
                    value={form.lastName || ""}
                    label={t("form.lastName")}
                    handleOnChange={setOption("lastName")}
                    isInvalid={invalid.lastName}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginBottom: 8,
                    }}
                    inputProps={{ style: { fontSize: "16px" } }}
                  />
                  <Footnote>{t("form.taxDeductibleNote")}</Footnote>
                </div>
              )}
            </InputGroup>
            {isMobile && (
              <>
                <Footnote style={{ marginTop: 11 }}>
                  *{t("form.taxDeductibleNote")}
                </Footnote>
              </>
            )}

            {/* <InputGroup as={Row} style={{ padding: 0, margin: 0}}>
                    <Col style={{ padding: 0, margin: 0 }}/>
                    <LabelInput label="First Name*" placeholder="Chinese" handleOnChange={setOption('firstNameZh')} style={{marginLeft: 13}} />
                    <LabelInput label="Last Name*" placeholder="Chinese" handleOnChange={setOption('lastNameZh')} style={{marginLeft: 13}} />
                </InputGroup> */}

            <InputGroup
              as={Row}
              style={{
                padding: 0,
                margin: 0,
                marginTop: 19,
                marginBottom: 11,
                alignItems: "center",
              }}
            >
              <FormControl
                style={{
                  flex: 0.4,
                  padding: 0,
                  margin: 0,
                  border: "solid 2px #ecf0f1",
                  backgroundColor: "#ffffff",
                  paddingLeft: 8,
                  height: 44,
                  fontFamily: useChinese ? "Microsoft JhengHei" : "Rambla",
                  ...(invalid.areaCode ? { borderColor: "red" } : {}),
                }}
                onChange={(event: any) =>
                  setOption("areaCode")(event.target.value)
                }
                placeholder={`${t("form.areaCode")}`}
                value={form.areaCode}
              />
              <Col style={{ flex: 2, padding: 0, margin: 0, marginLeft: 12 }}>
                <InputGroup>
                  <LabelInput
                    label={t("form.phone")}
                    maxLength={20}
                    placeholder=""
                    handleOnChange={setOption("phoneNumber")}
                    isInvalid={invalid.phoneNumber}
                    value={form.phoneNumber || ""}
                  />
                </InputGroup>
              </Col>
            </InputGroup>
            {(invalid.phoneNumber || invalid.areaCode) && (
              <Footnote style={{ color: "red", marginBottom: 8 }}>
                {t("form.phoneLengthRequired", { length: MIN_PHONE_LENGTH })}
              </Footnote>
            )}
            {isLogin && (
              <CheckBox
                containerStyle={{ margin: "8px 0px", alignItems: "center" }}
                textStyle={{ marginLeft: 12 }}
                optionText={t("form.overrideWestkowloonAccounts")}
                onChange={() =>
                  setOption("overrideWestkowloonAccounts")(TOGGLE_SWITCH)
                }
                type="checkbox"
                name="overrideWestkowloonAccounts"
                id={`default-event-info`}
                checked={form.overrideWestkowloonAccounts}
              />
            )}
            <InputGroup>
              <LabelInput
                label={t("email")}
                placeholder=""
                readOnly={isLogin}
                handleOnChange={setOption("primaryEmail")}
                isInvalid={invalid.primaryEmail}
                value={form.primaryEmail || ""}
              />
              {/* <LabelInput label="Date of birth" placeholder="" handleOnChange={setOption('dob')} style={{ marginLeft: 25 }}/> */}
            </InputGroup>
            <InputGroup as={Row} style={{ marginBottom: 11 }}>
              <Col style={{ padding: 0, margin: 0, flex: 0.33 }} />
              <Col style={{ padding: 0, margin: 0, flex: 2 }}>
                <Footnote style={{ color: "red" }}>{`${
                  invalid.primaryEmail ? "Email is invalid." : ""
                }`}</Footnote>
              </Col>
            </InputGroup>

            {donationForm.includes("pArts") && (
              <div style={{ marginTop: 8 }}>{renderAddressLines()}</div>
            )}

            {/*
                <FormHeading useChinese={useChinese} style={{ marginBottom: 8, marginTop: 32 }}>{t('form.venuesHeader')}</FormHeading>
                <Divider/>

                */}

            {/*

                <Form.Group>


                <Col style={{ padding: 0, margin: 0, marginTop: 19 }}>
                    <Row style={{ padding: 0, margin: 0 }}>
                        {VENUES.slice(0, 4).map((value, index) => (
                            <CheckBox
                                key={index}
                                value={value}
                                containerStyle={{ width: (index ? "24%" : "28%"), alignItems: 'center' }}
                                textStyle={{ paddingLeft: 8}}
                                optionText={t(`venue.${value}`)}
                                name={'customerInterest'}
                                checked={form.customerInterest.indexOf(value) > -1}
                                onChange={() => setOption('customerInterest')(value)}
                                type="checkbox"
                                id={`id-${value}`}
                            />
                        ))}
                    </Row>
                    <Row style={{ padding: 0, margin: 0, marginTop: 8 }}>
                        {VENUES.slice(4).map((value, index) => (
                            <CheckBox
                                key={index}
                                value={value}
                                containerStyle={{ width: (index ? "24%" : "28%"), alignItems: 'center' }}
                                textStyle={{ paddingLeft: 8}}
                                optionText={t(`venue.${value}`)}
                                name={'customerInterest'}
                                checked={form.customerInterest.indexOf(value) > -1}
                                onChange={() => setOption('customerInterest')(value)}
                                type="checkbox"
                                id={`id-${value}`}
                            />
                        ))}
                    </Row>
                </Col>
                </Form.Group>
*/}
            {/* {invalid.customerInterest && <Footnote style={{color: 'red', marginTop: 8}}>{t('required')}</Footnote>} */}

            {!hasDefaultLg && (
              <>
                <FormHeading
                  useChinese={useChinese}
                  style={{ marginBottom: 8, marginTop: 54 }}
                >
                  {t("form.languagePref")}
                </FormHeading>
                <Divider />
                <Form.Group style={{ marginTop: 19, marginBottom: 42 }}>
                  <Row style={{ padding: 0, margin: 0 }}>
                    {["English", "繁中"].map((value, index) => (
                      <CheckBox
                        key={index}
                        value={value}
                        containerStyle={{
                          paddingRight: 26,
                          alignItems: "center",
                        }}
                        textStyle={{
                          paddingLeft: 8,
                          ...(invalid.preferredLanguage
                            ? { color: "red" }
                            : {}),
                        }}
                        optionText={t(value) || value}
                        name="language"
                        checked={form.preferredLanguage === value}
                        onChange={() => setOption("preferredLanguage")(value)}
                        type="radio"
                        id={`id-${value}`}
                      />
                    ))}
                  </Row>
                  {invalid.preferredLanguage && (
                    <Footnote style={{ color: "red", marginTop: 8 }}>
                      {t("required")}
                    </Footnote>
                  )}
                </Form.Group>
              </>
            )}

            <FormHeading useChinese={useChinese} style={{ marginBottom: 8 }}>
              {t("form.receipt")}
            </FormHeading>
            <Divider />
            {/* <Form.Group>
                    {['No. I don\'t need a receipt.', 'e-receipt', 'receipt by post'].map(value => (
                        // <div key={`default-${value}`} className="radio" style={{ alignItems: 'center'}}>
                            <Form.Check key={`receipt-radio-${value}`} style={{ paddingTop: 9 }}>
                                <Form.Check.Input
                                    onClick={() => setOption('receipt')(value)}
                                    type="radio"
                                    name="receipt"
                                    id={`default-${value}`}
                                    // checked={form.receipt === value}
                                />
                                <OptionText style={{paddingTop: 6}}>{value}</OptionText>
                            </Form.Check>
                        // </div>
                    ))}
                </Form.Group> */}
            <OptionText
              useChinese={useChinese}
              style={{ color: "#78848f", marginTop: 8 }}
            >
              {/* Donate HK$100 or above is eligible for a tax-deductible receipt. Please provide full address to avoid mail failure. */}
              {donationForm.includes("pArts")
                ? t("form.receiptNote_pa")
                : t("form.receiptNote")}
            </OptionText>
            <CheckBox
              containerStyle={{ marginTop: 8, alignItems: "center" }}
              textStyle={{ marginLeft: 12 }}
              optionText={
                donationForm.includes("pArts")
                  ? t("form.receiptCheckboxNote_pa")
                  : t("form.receiptCheckboxNote")
              }
              name="receipt"
              onChange={() => setOption("receipt")(TOGGLE_SWITCH)}
              type="checkbox"
              id={`default-receipt`}
              checked={form.receipt}
            />
            {form.receipt && !donationForm.includes("pArts") && (
              <div style={{ marginTop: 8 }}>{renderAddressLines()}</div>
            )}
            <FormHeading
              useChinese={useChinese}
              style={{ marginBottom: 8, marginTop: 48 }}
            >
              {t("form.PICHeader")}
            </FormHeading>
            <Divider style={{ marginBottom: 15 }} />
            <CheckBox
              containerStyle={{ marginTop: 8, alignItems: "flex-start" }}
              textStyle={{ marginLeft: 12, width: "100%" }}
              checked={form.tcPicsRead || false}
              inputStyle={{ width: "30px" }}
              onChange={() => setOption("tcPicsRead")(TOGGLE_SWITCH)}
              type="checkbox"
              name="tcPicsRead"
              id={`default-collect-info`}
              optionText={
                <>
                  <OptionText
                    useChinese={useChinese}
                    style={{ ...(invalid.tcPicsRead ? { color: "red" } : {}) }}
                  >
                    {t("form.PICStatement1")}
                    <span
                      style={{ textDecoration: "underline", color: "#007bff" }}
                      onClick={() => {
                        setShowLink(true);
                        setModalTarget("PTN");
                      }}
                    >
                      {t("form.termsAndConditions")}
                    </span>
                    {t("form.and")}
                    <span
                      style={{ textDecoration: "underline", color: "#007bff" }}
                      onClick={() => {
                        setShowLink(true);
                        setModalTarget("PICS");
                      }}
                    >
                      {t("form.PICS")}
                    </span>
                    {t("form.PICStatement2")}
                  </OptionText>
                  {invalid.tcPicsRead && (
                    <Footnote
                      useChinese={useChinese}
                      style={{ marginTop: 8, color: "red", fontWeight: "bold" }}
                    >
                      {t("requiredTerms")}
                    </Footnote>
                  )}
                  <OptionText
                    useChinese={useChinese}
                    style={{
                      marginTop: 16,
                      marginBottom: 16,
                      fontWeight: "bold",
                      textDecoration: "underline",
                    }}
                  >
                    {t("form.dataUseMarketing")}
                  </OptionText>
                </>
              }
            />
            {/* <CheckBox
                    containerStyle={{ marginTop: 8, alignItems: 'center' }}
                    textStyle={{ marginLeft: 12 }}
                    optionText={
                        <OptionText useChinese={useChinese}>
                            {t('form.marketingPurpose')}
                        </OptionText>
                    }
                    onChange={() => setOption('marketingPurpose')(TOGGLE_SWITCH)}
                    type="checkbox"
                    name="marketingPurpose"
                    id={`default-event-info`}
                    checked={form.marketingPurpose}
                /> */}
            <OptionText useChinese={useChinese}>
              {t("form.marketingPurpose")}
            </OptionText>
            <CheckBox
              containerStyle={{ marginTop: 8, alignItems: "center" }}
              textStyle={{ marginLeft: 12, width: "100%" }}
              optionText={t("form.checkboxReceiveInfo")}
              onChange={() => setOption("receiveEventInfo")(TOGGLE_SWITCH)}
              type="checkbox"
              name="receiveEventInfo"
              id={`default-event-info`}
              checked={form.receiveEventInfo}
            />
            <CheckBox
              containerStyle={{
                marginTop: 8,
                alignItems: "center",
                display: "none",
              }}
              textStyle={{ marginLeft: 12, width: "100%" }}
              optionText={t("form.checkboxReceiveDevUpdates")}
              onChange={() => setOption("receiveDevUpdate")(TOGGLE_SWITCH)}
              type="checkbox"
              name="receiveDevUpdate"
              id={`default-development-updates`}
              checked={form.receiveDevUpdate}
            />
            <Footnote
              style={{ marginTop: 4, display: "none" }}
              useChinese={useChinese}
            >
              {t("form.eNewsNotification")}
            </Footnote>
          </Form>
          {renderButton(isMobile)}
        </Col>
        <Col style={{ padding: 0, margin: 0 }} xs={0} sm={1} md={1} lg={1} />
      </Row>
      <Modal show={showLink} size="xl" onHide={() => setShowLink(false)}>
        <Modal.Header closeButton></Modal.Header>
        {modalTarget === "PICS" ? (
          <div style={{ padding: "0px 10px 10px 10px" }}>
            <h1 style={{ fontSize: "2em", fontWeight: "bold" }}>
              {t("PICS.title")}
            </h1>
            <div style={{ border: "thin solid black" }}>
              <div style={{ margin: "1em" }}>
                <h2
                  style={{
                    fontSize: "1em",
                    fontWeight: "bold",
                    marginBottom: "0",
                    textDecoration: "underline",
                  }}
                >
                  {t("PICS.CollectionOfYourPersonalData_title")}
                </h2>
                <p style={{ fontSize: "1em" }}>
                  {t("PICS.CollectionOfYourPersonalData_text")}
                </p>
              </div>
              <div style={{ margin: "1em" }}>
                <h2
                  style={{
                    fontSize: "1em",
                    fontWeight: "bold",
                    marginBottom: "0",
                    textDecoration: "underline",
                  }}
                >
                  {t("PICS.PurposesOfPersonalDataCollectionAndUsage_title")}
                </h2>
                <p style={{ fontSize: "1em" }}>
                  {t("PICS.PurposesOfPersonalDataCollectionAndUsage_line_1")}
                </p>
                <ul>
                  <li>
                    {t("PICS.PurposesOfPersonalDataCollectionAndUsage_point_1")}
                  </li>
                  <li>
                    {t("PICS.PurposesOfPersonalDataCollectionAndUsage_point_2")}
                  </li>
                  <li>
                    {t("PICS.PurposesOfPersonalDataCollectionAndUsage_point_3")}
                  </li>
                  <li>
                    {t("PICS.PurposesOfPersonalDataCollectionAndUsage_point_4")}
                  </li>
                  <li>
                    {t("PICS.PurposesOfPersonalDataCollectionAndUsage_point_5")}
                  </li>
                  <li>
                    {t("PICS.PurposesOfPersonalDataCollectionAndUsage_point_6")}
                  </li>
                  <li>
                    {t("PICS.PurposesOfPersonalDataCollectionAndUsage_point_7")}
                  </li>
                </ul>
              </div>
              <div style={{ margin: "1em" }}>
                <p style={{ fontSize: "1em", marginBottom: "0" }}>
                  {t("PICS.PurposesOfPersonalDataCollectionAndUsage_line_2")}
                </p>
                <ul>
                  <li>
                    {t("PICS.PurposesOfPersonalDataCollectionAndUsage_point_8")}
                  </li>
                  <li>
                    {t("PICS.PurposesOfPersonalDataCollectionAndUsage_point_9")}
                  </li>
                  <li>
                    {t(
                      "PICS.PurposesOfPersonalDataCollectionAndUsage_point_10"
                    )}
                  </li>
                </ul>
              </div>
              <div style={{ margin: "1em" }}>
                <p style={{ fontSize: "1em" }}>
                  {t("PICS.PurposesOfPersonalDataCollectionAndUsage_line_3")}
                </p>
              </div>
              <div style={{ margin: "1em" }}>
                <h2
                  style={{
                    fontSize: "1em",
                    fontWeight: "bold",
                    marginBottom: "0",
                    textDecoration: "underline",
                  }}
                >
                  {t("PICS.TransferOfPersonalData_title")}
                </h2>
                <p style={{ fontSize: "1em" }}>
                  {t("PICS.TransferOfPersonalData_line_1")}
                </p>
              </div>
              <div style={{ margin: "1em" }}>
                <h2
                  style={{
                    fontSize: "1em",
                    fontWeight: "bold",
                    marginBottom: "0",
                    textDecoration: "underline",
                  }}
                >
                  {t("PICS.TransferOfPersonalDataOutsideHongKong_title")}
                </h2>
                <p style={{ fontSize: "1em" }}>
                  {t("PICS.TransferOfPersonalDataOutsideHongKong_text_1")}
                </p>
              </div>
              <div style={{ margin: "1em" }}>
                <h2
                  style={{
                    fontSize: "1em",
                    fontWeight: "bold",
                    marginBottom: "0",
                    textDecoration: "underline",
                  }}
                >
                  {t("PICS.PersonalDataSecurityAndRetentionOfData_title")}
                </h2>
                <p style={{ fontSize: "1em" }}>
                  {t("PICS.PersonalDataSecurityAndRetentionOfData_text_1")}
                </p>
              </div>
              <div style={{ margin: "1em" }}>
                <h2
                  style={{
                    fontSize: "1em",
                    fontWeight: "bold",
                    marginBottom: "0",
                    textDecoration: "underline",
                  }}
                >
                  {t("PICS.Personaldatasecurityandretentionofdatatitle")}
                </h2>
                <p style={{ fontSize: "1em" }}>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t(
                        "PICS.Personaldatasecurityandretentionofdatatext_1",
                        { interpolation: { escapeValue: false } }
                      ),
                    }}
                  />
                </p>
              </div>
              <div style={{ margin: "1em" }}>
                <h2
                  style={{
                    fontSize: "1em",
                    fontWeight: "bold",
                    marginBottom: "0",
                    textDecoration: "underline",
                  }}
                >
                  {t("PICS.UseOfDataInDirectMarketing_title")}
                </h2>
                <p style={{ fontSize: "1em" }}>
                  {t("PICS.UseOfDataInDirectMarketing_text_1")}
                </p>
                <p style={{ fontSize: "1em" }}>
                  {t("PICS.UseOfDataInDirectMarketing_text_2")}
                </p>
              </div>
              <div style={{ margin: "1em" }}>
                <p style={{ fontSize: "1em" }}>
                  {t("PICS.UseOfDataInDirectMarketing_text_3")}
                </p>
                <ul>
                  <li>{t("PICS.UseOfDataInDirectMarketing_point_1")}</li>
                  <li>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t("PICS.UseOfDataInDirectMarketing_point_2", {
                          interpolation: { escapeValue: false },
                        }),
                      }}
                    />
                  </li>
                  <li>{t("PICS.UseOfDataInDirectMarketing_point_3")}</li>
                </ul>
              </div>
              <div style={{ margin: "1em" }}>
                <p style={{ fontSize: "1em" }}>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t("PICS.UseOfDataInDirectMarketing_text_4", {
                        interpolation: { escapeValue: false },
                      }),
                    }}
                  />
                </p>
              </div>
              <div style={{ margin: "1em" }}>
                <h2
                  style={{
                    fontSize: "1em",
                    fontWeight: "bold",
                    marginBottom: "0",
                    textDecoration: "underline",
                  }}
                >
                  {t("PICS.LanguageVersions_title")}
                </h2>
                <p style={{ fontSize: "1em" }}>
                  {t("PICS.LanguageVersions_line_1")}
                </p>
              </div>
              <div style={{ margin: "1em" }}>
                <p style={{ fontSize: "1em" }}>
                  {t("PICS.picsLatestUpdateDate")}
                </p>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        {modalTarget === "PTN" ? (
          <div style={{ padding: "0px 10px 10px 10px" }}>
            <h1 style={{ fontSize: "2em", fontWeight: "bold" }}>
              {t("PTN.title")}
            </h1>
            <div style={{ border: "thin solid black" }}>
              <div style={{ margin: "1em" }}>
                <ol>
                  <li>{t("PTN.ptnLine1")}</li>
                  <li>{t("PTN.ptnLine2")}</li>
                  <li>{t("PTN.ptnLine3")}</li>
                  <li>{t("PTN.ptnLine4")}</li>
                  <li>{t("PTN.ptnLine5")}</li>
                  <li>{t("PTN.ptnLine6")}</li>
                  <li>{t("PTN.ptnLine7")}</li>
                  <li>{t("PTN.ptnLine8")}</li>
                  <li>{t("PTN.ptnLine9")}</li>
                </ol>
                <p>{t("PTN.ptnLineAsterisk")}</p>
                <p>{t("PTN.ptnLatestUpdateDate")}</p>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        {/* <div style={{height: 600}}>
                <iframe src={link} style={{width: '100%', height: '100%'}}/>
            </div> */}
      </Modal>
    </Container>
  );
};

export default withRouter(DonationForm);
